import React from "react";
import { Navigation, Pagination, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Blog from "./blog";
import Icon from "./icon";
import { Link } from "./link";
import { useTranslation } from "react-i18next";

const BlogSlider = ({ id = "related-post", title, items }) => {
  const { t } = useTranslation();
  return (
    <section id={id}>
      <div className="blog-slider">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="box__header">
                <h2 className="h3 page__section-title">{title}</h2>
                <div className="box__divider-vert"></div>
                <Link to="/insights" className="button button--simple">
                  <span className="color-secondary-light">{t("seeAll")}</span>
                  <Icon name="arrow-right" width={14} height={15} />
                </Link>
              </div>
            </div>
            <div className="col-12">
              <Swiper
                className="overflow-visible"
                modules={[EffectFade, Pagination, Navigation]}
                pagination={{ clickable: true }}
                spaceBetween={50}
                slidesPerView={1}
                breakpoints={{
                  992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                  },
                }}
              >
                {items.map((item) => (
                  <SwiperSlide key={(item.hasOwnProperty("node") ? item.node : item).contentful_id}>
                    <Blog data={item.hasOwnProperty("node") ? item.node : item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSlider;
